import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
  withCredentials: true,

});


// Get user profile
export const getUserProfile = async () => {
  try {
    const response = await api.get('/user/profile');
    return {
      success: true,
      user: response.data.user,
    };
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

// Update personal details
export const updatePersonalDetails = async (userData) => {
  try {
    const response = await api.put('/user/profile', userData);
    return {
      success: true,
      user: response.data.user,
      message: response.data.message,
    };
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};


// Change password
export const changePassword = async (passwordData) => {
  try {
    const response = await api.put('/user/change-password', passwordData);
    return {
      success: true,
      message: response.data.message,
    };
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

// Upload profile picture
export const uploadProfilePicture = async (formData) => {
  try {
    const response = await api.put('/user/profile-picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return {
      success: true,
      user: response.data.user,
      message: response.data.message,
    };
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

// Delete profile picture
export const deleteProfilePicture = async () => {
  try {
    const response = await api.delete('/user/profile-picture');
    return {
      success: true,
      user: response.data.user,
      message: response.data.message,
    };
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};